module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/2.7.6-61.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/2.7.6.md
// module id = 478
// module chunks = 477